import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MenuLinkTitle from 'components/dashboard/menu-links-content/MenuLinkTitle';
import CommonLinkDeleteButton from 'components/common/link-elements/CommonLinkDeleteButton';
import MenuLinkIsPublished from '../MenuLinkIsPublished';
import './MenuLinkItemHeaderContent.css';

function MenuLinkItemHeaderContent(props) {
  const { item, deleteMenuLink } = props;
  const [error, setError] = useState(false);

  return (
    <div className="menu-link-item-header__component">
      <div className="title">
        <MenuLinkTitle
          linkItem={item}
          setError={setError}
        />
      </div>
      <div className="delete">
        <CommonLinkDeleteButton
          key={`menu-link-delete-icon-key-${item.id}`}
          linkItem={item}
          deleteFunction={deleteMenuLink}
        />
      </div>
      <div className="is-published">
        <MenuLinkIsPublished
          linkItem={item}
          error={error}
        />
      </div>      
    </div>
  );
}

MenuLinkItemHeaderContent.propTypes = {
  item: PropTypes.object.isRequired,
  deleteMenuLink: PropTypes.func.isRequired,
}

export default MenuLinkItemHeaderContent;